import _ from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { Container, Image, Menu } from 'semantic-ui-react'

import logo from 'resources/logo.png'

const NavbarDesktop = ({ leftItems, rightItems }) => (
  <Menu fixed='top' size='huge' inverted>
    <Container>
      {_.map(leftItems, item => <Menu.Item {...item} />)}
      <Menu.Menu position='right'>
        {_.map(rightItems, item => <Menu.Item {...item} />)}
      </Menu.Menu>
    </Container>
  </Menu>
)

NavbarDesktop.propTypes = {
  leftItems: PropTypes.arrayOf(PropTypes.object),
  rightItems: PropTypes.arrayOf(PropTypes.object),
}

export default NavbarDesktop



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarDesktop.js